import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import FbtCard from '../FbtCard';
import { STATUS } from '@app/constants/commonConstants';
import styles from '../FrequentlyBoughtTogether.module.scss';

const CurrentItem = ({ getFitmentResult, handleCheckBox }) => {
  const [t] = useTranslation();
  const current = useSelector(s => s.products?.current);
  const partNumber = useSelector(s => s.products?.byId?.[current]?.partNumber);
  const partName = useSelector(s => s.products.byId?.[current]?.name);
  const imageURL = useSelector(s => s.products?.byId?.[current]?.imageURL);
  const priceAndAvailability = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]
  );
  const discountedPrice = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.discountedPrice
  );
  const totalPrice = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.totalPrice
  );
  const price = totalPrice === discountedPrice ? totalPrice : discountedPrice;
  const unformattedUnitPrice = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.unformattedUnitPrice
  );
  const enableAddToCart = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.enableAddToCart
  );
  const loadingStatus = useSelector(s => s.products?.getMarketingPriceStatus);
  const isCatCorp = useSelector(s => s.common.isCatCorp);
  const thisItemStyle = `d-flex align-items-center justify-content-center m-0 u-fs--10 bg--LightGray text-univers--bold u-color--Black text-uppercase ${styles['itemHeading']}`;
  const getCurrentItem = () => {
    if (enableAddToCart !== undefined) {
      if (enableAddToCart) {
        return (
          <FbtCard
            partName={`${partNumber}: ${partName}`}
            imageData={{ url: imageURL, title: partNumber }}
            getFitmentResult={getFitmentResult}
            price={enableAddToCart && price}
            partNumber={partNumber}
            unformattedUnitPrice={unformattedUnitPrice}
            handleCheckBox={handleCheckBox}
            loadingStatus={loadingStatus}
          />
        );
      } else {
        return (
          <FbtCard
            partName={`${partNumber}: ${partName}`}
            imageData={{ url: imageURL, title: partNumber }}
            getFitmentResult={getFitmentResult}
          />
        );
      }
    }
  };

  return (
    <div className={cx('border-LightGray mb-3', styles['itemCard'])}>
      <p className={thisItemStyle}>{t('PDP_THIS_ITEM')}</p>
      {isCatCorp || priceAndAvailability.loadingStatus === STATUS.REJECTED ? (
        <FbtCard
          partName={`${partNumber}: ${partName}`}
          imageData={{ url: imageURL, title: partNumber }}
          getFitmentResult={getFitmentResult}
        />
      ) : (
        getCurrentItem()
      )}
    </div>
  );
};

CurrentItem.propTypes = {
  getFitmentResult: PropTypes.func,
  handleCheckBox: PropTypes.func
};

export default CurrentItem;
